import React, { useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';

const BenefitsMotionGraphics = props => {
  const slider = useRef();

  const settings = {
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrow: false,
    autoplay: true,

    responsive: [
      {
        breakpoint: 767,
        settings: {
          autoplay: false,
          slidesToShow: 1,
          slidesToScroll: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerMode: true,
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>{`
             .slick-list:first-of-type,for-hover:first-of-type{
                                padding-left:0!important
                            }
             .slick-slide {
                    outline: none
                }
                .slick-slide div {
                    outline: none
                }
                .slick-slide:focus,.slick-slide a{
                    outline: none;
                }
                .shadow-new{
                    box-shadow: 0px 1px 3px 1px rgb(0 0 0 / 7%);
                    border-radius: 0px 0px 25px 25px;
                }
                .shadow-new-w{
                    box-shadow: 0px 1px 6px 1px rgb(0 0 0 / 7%);
                }
                .custom-dots{
                      display:flex!important    ;
                      justify-content:center;
                  }
                  .custom-dots li{
                      position:relative;
                      margin:0 3px;
                      margin-top:20px;
                      width:50px;
                      height:2px;
                      background-color: #C4C4C4;
                      overflow:hidden;
                  }
                  .custom-dots li.slick-active{
                      background-color:#670F7A;
                  }
                  .custom-dots li button{
                      position:absolute;
                      width:100%;
                      height:100%;
                      top:0;
                      left:0;
                      opacity:0;
                      //display:none;
                  }
            
            `}</style>
      <Slider ref={slider} {...settings} className="relative z-10 pt-24   ">
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Time & Budget-Friendly Solution</h3>
          <div className={' border-gray-dark border-r-0 md:border-r-1'}>
            <div className={'pr-0 md:pr-30'}>
              Non-dynamic solutions have no place in this digital world. The only trump cards here are speed and value. That's what the motion
              graphics explainer videos provide: streamlined process, reduced time, and cost savings.
            </div>
          </div>
        </div>
        <div className={'w-30p block pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14  px-0 md:px-30 '}>Multi-Versatile Tool</h3>
          <div className={'w-full  border-gray-dark border-r-0 md:border-r-1'}>
            <div className={' px-0 md:px-30 '}>
              It doesn't matter what your brand identity, message, or preferred platform is; explainer videos with motion design work for you. Immerse
              your audience in the animated play of vivid colors, graphics, and text. Rest assured, it will leave a lasting impact.
            </div>
          </div>
        </div>
        <div className={'w-30p block pl-0 md:pl-30 pr-15'}>
          <h3 className={'text-green font-bold text-24 leading-29 mb-14'}>Impactful Storytelling.</h3>
          Motion graphics videos allow you to weave your brand story with the brightest colors. Everything from the graphics you choose to the
          movement, music, and typography can help you create the tone and style you want to position your brand.
        </div>
      </Slider>
    </>
  );
};
export default BenefitsMotionGraphics;
